import {FormGroup} from '@angular/forms';
import {EventEmitter, QueryList} from '@angular/core';
import {FilterFieldClearDirective} from '../filter-field-clear.directive';

export abstract class AbstractFilterComponent {
    visible: boolean = true;

    abstract form: FormGroup;
    abstract columns: number = 3;
    abstract verticalAlignment: boolean = false;

    abstract onSearch: EventEmitter<any> = new EventEmitter();

    abstract filterFieldComponents: QueryList<FilterFieldClearDirective>;

    changeVisibility() {
        this.visible = !this.visible;
    }

    isFormInvalid(): boolean {
        return this.form.pristine && this.form.invalid
    }

    public getCurrentFilterValues(): any {
        return this.form.value;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/filter/container/abstract.filter.component.ts